// eslint-disable-next-line import/no-unused-modules
import {
  calcOriginalYearlyPrice,
  calcYearlyPrice,
  Insurance,
} from '@/pages/LocationPage/helpers'
import { useMemo } from 'react'

interface PriceCalculationsResult {
  totalPrice: number
  originalPrice: number
  discount: number
  displayPrice: number
  displayGrossPrice: number
  displayDiscount: number
  displayPeriod: 'yearly'
}

export const usePriceCalculations = (
  data: Insurance[],
): PriceCalculationsResult => {
  const totalPrice = useMemo(() => calcYearlyPrice(data), [data])
  const originalPrice = useMemo(() => calcOriginalYearlyPrice(data), [data])

  const discount = useMemo(() => originalPrice - totalPrice, [
    originalPrice,
    totalPrice,
  ])

  return {
    totalPrice,
    originalPrice,
    discount,
    displayPrice: totalPrice,
    displayGrossPrice: totalPrice,
    displayDiscount: discount,
    displayPeriod: 'yearly',
  }
}
